import React, { forwardRef } from 'react';

import cx from '@3ui/cx';

import styles from './Tab.module.css';
import { TabProps as Props } from './types.js';

const DefaultTag = forwardRef((props, ref: React.Ref<HTMLAnchorElement>) => (
  <a {...props} ref={ref} />
));

export const Tab = forwardRef(
  (
    { isSelected, el: Tag = DefaultTag, className, ...otherProps }: Props,
    ref: React.Ref<HTMLElement>
  ) => (
    <Tag
      className={cx(styles.root, className)}
      ref={ref}
      {...otherProps}
      data-selected={String(isSelected)}
    />
  )
);
